module.exports = __webpack_public_path__ + "static/media/Mapa-Rio de Janeiro.3ed9b62c.svg";